module.exports = __webpack_public_path__ + "static/media/Avatar4.29671cb8.svg";